/**
 * Frame of a full-page screen (a detail, the role builder): full width with the prototype's inset
 * (8px 32px 64px), like the list pages. `PageContainer`'s centered `max-w-7xl` does not match it.
 *
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 */
const FullPageFrame = ({ children }) => (
  <main className="scrollbar-aimsos-auto-sm flex-1 overflow-y-auto bg-surface-base">
    <div className="flex min-h-full flex-col gap-6 px-8 pb-16 pt-2">{children}</div>
  </main>
);

export default FullPageFrame;
